import {
    Box,
    Button,
    Modal,
    Text,
    rem,
  } from "@mantine/core";
  import { useEffect, useState } from "react";
  import useStyles from "./modalStyle";
  import CloseCircle from "../CloseCircle";
  import { DatePickerInput } from "@mantine/dates";
  import { forceMovePlanToActive, getPlans } from "../../services/supportplan";
  
  const ForceMoveCarePlan = ({
    client,
    data,
    opened,
    onclose,
    rowData,
  }) => {
    console.log("🚀 ~ ForceMoveCarePlan ~ client:", client)
    console.log("🚀 ~ ForceMoveCarePlan ~ rowData:", rowData)
    console.log("🚀 ~ ForceMoveCarePlan ~ data:", data)
    const { classes } = useStyles();
    const [btnLoading, setBtnLoading] = useState(false);
    const [date, setDate] = useState(new Date());
  
    useEffect(() => {
      if (opened) {
        resetState();
      }
    }, [opened]);
  
    const resetState = () => {
      setDate(new Date());
    };
  
    const handleClose = () => {
      resetState();
      onclose();
    };
  
    const onSave = async () => {
      setBtnLoading(true);
      try {
        const payload = {
          id: data?._id,
          endDate: date
        };
  
        const response = await forceMovePlanToActive(payload);
  
        if (response) {
          resetState();
          getPlans(1, client?.planDoc ? rowData?.client?._id : client, "discontinued")
          handleClose();
        }
        setBtnLoading(false);
      } catch (error) {
        console.error("Failed to Reactivate:", error);
      } finally {
        setBtnLoading(false);
      }
    };
  
    return (
      <>
        <Modal
              centered
              size={600}
              shadow="md"
              zIndex={1000}
              radius={"lg"}
              opened={opened}
              onClose={handleClose}
              overlayProps={{ blur: 3 }}
              className={classes.medicationModal}
            >
              <CloseCircle onclose={handleClose} />
              <Box className={classes.header}>
                <Text variant="text" fw={600} size={24}>
                  Are you sure, You want to reactivate careplan?
                </Text>
              </Box>
              <Box className={classes.mainContentWarpper}>
                <Box className={classes.mainContent} style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px'}}>
                  <Text variant="text" fw={400} size={16} m={10}>
                    Please select new end date for the care plan
                  </Text>
                  <Box className={classes.selectBoxDate} style={{width: '100%'}}>
                    <Box className={classes.datePicker}>
                      <DatePickerInput
                        label="End Date"
                        size="sm"
                        value={date}
                        onChange={(date) => {
                          setDate(new Date(date));
                        }}
                        minDate={new Date()}
                        placeholder="mm/dd/yyyy"
                        rightSection={
                          <img
                            style={{ width: "30px" }}
                            src={"/assets/images/calendar-icon.png"}
                            alt="Icon"
                          />
                        }
                        withAsterisk
                        styles={{ rightSection: { pointerEvents: "none" } }}
                      />
                    </Box>
                  </Box>
                  <Box className={classes.buttons}>
                    <Button
                      onClick={() => onclose()}
                      variant="outline"
                      color="green"
                      shape="circle"
                      radius="xl"
                    >
                      Cancel
                    </Button>
                    <Button
                      id="discontinue"
                      onClick={() => onSave()}
                      variant="filled"
                      color="green"
                      shape="circle"
                      radius="xl"
                      loading={btnLoading}
                    >
                      Reactivate
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Modal>
      </>
    );
  };

  export default ForceMoveCarePlan;
  